const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const OfficeModal = require("../office/modals/OfficeModal");
const LoadingCircle = require("../core/view/LoadingCircle");
const Dropdown = require("./SchoolDropdown");
const OpsSchool = require("./vault/OpsSchool");
const GradeChapter = require("../../shared/GradeChapter");
const UserSearch = require("./UserSearch");
const CopyTable = require("./data/CopyTable");
const InfoIcon = require("../office/InfoIcon");
const LoadGuard = require("../core/view/LoadGuard");
const ClassesUtil = require("./util/ClassesUtil");
const {isValidEmail} = require("../../shared/StringUtil");
const {ALLOWED_CLASS_GRADES} = require("../../shared/Constants");
const {getDisplayedGradeLabel} = require("../../shared/SchoolUtil");

const styles = require("./styles/AddModal.css");

module.exports = createReactClass({
	displayName: "AddModal",

	propTypes: {
		user: PT.object.isRequired,
		type: PT.oneOf([
			"school",
			"class",
			"purchaseAdmin",
			"schoolAdmin",
			"teacher",
			"student",
			"transfer",
			"teacherAddClass",
		]),
		onAddOrTransfer: PT.func.isRequired,
		generatedUsernameObj: PT.object,
		generateUsername: PT.func,
		status: PT.string,
		error: PT.string,
		errorMoreInfo: PT.string,
		onClose: PT.func,
		userID: PT.number,
		classID: PT.number,
		schoolID: PT.number,
		schoolState: PT.object,
	},

	getInitialState() {
		const {type, schoolState, schoolID, classID} = this.props;
		// This is needed to set an initial value to these fields, or else React will warn about going from uncontrolled to controlled input.
		let fields = []; // input fields
		const typeIsStaff = _.includes(
			["purchaseAdmin", "schoolAdmin", "teacher"],
			type
		);
		if (typeIsStaff) {
			fields = ["firstName", "lastName", "email"];
		} else if (type === "student") {
			fields = [
				"displayName",
				"firstName",
				"lastName",
				"password",
				"intStudentID",
				"schoolLogin",
			];
		} else if (type === "school" || type === "class") {
			fields = ["displayName"];
		}

		let selectedSchoolID = schoolID || null;
		if (!selectedSchoolID && this.typeNeedsSchool(type)) {
			const validSchools = this.getValidSchools();
			selectedSchoolID = validSchools.length === 1 ? validSchools[0].id : null;
		}

		let selectedClassID = classID || null;
		if (!selectedClassID && this.typeNeedsClass(type)) {
			const validClasses = this.getValidClasses(selectedSchoolID);
			selectedClassID = validClasses.length === 1 ? validClasses[0].id : null;
		}

		return {
			values: _.zipObject(
				fields,
				fields.map(f => "")
			),
			selectedSchoolID,
			selectedClassID,
			selectedGradeID: null,
			selectedDisplayedGrade: null,
			selectedUser: null,
			selectedYear: OpsSchool.getPurchaseYear(schoolState),
			isTransfer: (type === "student" || typeIsStaff) && classID,
			errorType: null,
		};
	},

	onClose() {
		this.setState(this.getInitialState);
		this.props.onClose();
	},

	getOptionalFields() {
		const purchase = _.get(this.props.schoolState, "accounts.purchase");
		const fields = purchase.domain ? [] : ["schoolLogin"];
		if (this.props.type === "student") {
			fields.push("displayName");
		}
		return fields;
	},

	onCreate() {
		const {
			schoolID,
			classID,
			type,
			onAddOrTransfer,
			generatedUsernameObj,
		} = this.props;
		const {
			values,
			selectedSchoolID,
			selectedClassID,
			selectedGradeID: gradeID,
			selectedDisplayedGrade: displayedGrade,
			selectedUser,
			selectedYear,
			isTransfer,
		} = this.state;
		const optionalFields = this.getOptionalFields();
		const toTrim = [
			"firstName",
			"lastName",
			"email",
			"intStudentID",
			"schoolLogin",
		];
		toTrim.forEach(field => {
			if (values[field]) values[field] = _.trim(values[field]);
		});
		const missingInputs = isTransfer
			? !selectedUser
			: !_.isEmpty(values) && !_.every(_.omit(values, optionalFields), Boolean);

		if (
			missingInputs ||
			(this.typeNeedsSchool(type) &&
				type !== "teacher" &&
				!(schoolID || selectedSchoolID || classID)) ||
			(this.typeNeedsClass(type) &&
				type !== "teacher" &&
				!(classID || selectedClassID)) ||
			(type === "class" &&
				(displayedGrade === undefined ||
					displayedGrade === null ||
					displayedGrade === "")) ||
			(values.email && !isValidEmail(values.email))
		) {
			this.setState({errorType: "E_INVALID_INPUT"});
		} else {
			const vals = _.extend({}, values, {
				displayName: _.trim(values.displayName) || _.trim(values.firstName),
			});
			if (this.typeNeedsClass(type)) {
				vals.classID = parseInt(classID || selectedClassID);
			}
			if (this.typeNeedsSchool(type)) {
				vals.schoolID = parseInt(schoolID || selectedSchoolID);
			}
			if (type === "class") {
				if (gradeID) {
					vals.gradeID = parseInt(gradeID);
				}
				vals.year = parseInt(selectedYear);
				vals.displayedGrade = parseInt(displayedGrade);
			}
			if (isTransfer) {
				_.extend(vals, {userID: selectedUser.id});
			} else if (type === "student" && generatedUsernameObj.username) {
				vals.username = generatedUsernameObj.username;
			}
			onAddOrTransfer(type, vals, isTransfer);
		}
	},

	getKeyHandler(f) {
		return evt => {
			if (evt.which === 13) {
				f();
			}
		};
	},

	handleChange(evt, field) {
		const values = _.clone(this.state.values);
		values[field] = evt.target.value;
		this.setState({values, errorType: null});
	},

	updateSelection(type, val) {
		if (type === "selectedSchoolID" && this.state.selectedSchoolID !== val) {
			const classes = this.getValidClasses(parseInt(val));
			if (classes.length === 1) {
				this.setState({
					selectedSchoolID: val,
					selectedClassID: classes[0].id,
					errorType: null,
				});
			} else {
				this.setState({selectedSchoolID: val, errorType: null});
			}
		}
		if (this.state[type] !== val) {
			this.setState({[type]: val, errorType: null});
		}
	},

	toggleSwitch() {
		this.setState({isTransfer: !this.state.isTransfer});
	},

	renderInput(inputProps, tabIndex) {
		const {fieldType, placeholder} = inputProps;
		let inputClass = styles.input;
		let infoIcon;
		const inputVal = this.state.values[fieldType] || "";
		const infoCopy = CopyTable.getAddModalInfoIconCopy(fieldType);
		if (infoCopy) {
			infoIcon = (
				<InfoIcon
					className={styles.infoLabel}
					text={infoCopy}
					textClass={styles.infoText}
				/>
			);
		}
		const optionalFields = this.getOptionalFields();
		if (
			this.state.errorType === "E_INVALID_INPUT" &&
			!inputVal &&
			!_.includes(optionalFields, fieldType)
		) {
			inputClass += " " + styles.invalid;
		}
		return (
			<div className={styles.inputOuter} key={"input-" + fieldType}>
				<div className={styles.inputLabel}>
					{placeholder}
					{infoIcon}
				</div>
				<input
					className={inputClass}
					type={fieldType}
					value={inputVal}
					onChange={evt => this.handleChange(evt, fieldType)}
					onKeyPress={this.handleKeyPress}
					tabIndex={tabIndex}
				/>
			</div>
		);
	},

	renderClass(type) {
		const grades = GradeChapter.getActiveGrades();
		const classGrades = ALLOWED_CLASS_GRADES;
		const currYear = OpsSchool.getPurchaseYear(this.props.schoolState);

		const getYearText = y => {
			return y - 1 + "-" + y;
		};
		const years = [currYear, currYear + 1];
		const yearDisplays = [getYearText(currYear), getYearText(currYear + 1)];
		const yearOpts = _.zipObject(years, yearDisplays);
		return (
			<div className={styles.content}>
				{this.renderInput({
					fieldType: "displayName",
					placeholder: "class name",
				})}
				<div className={styles.rowInput}>
					<div>
						<div className={styles.inputLabel}>Grade</div>
						<Dropdown
							className={styles.gradeDropdown}
							options={_.zipObject(
								classGrades,
								classGrades.map(g => getDisplayedGradeLabel(g))
							)}
							defaultOption="Select a grade"
							initialValue={this.state.selectedDisplayedGrade}
							customSortedOptionKeys={classGrades.map(String)}
							updateSelection={val =>
								this.updateSelection("selectedDisplayedGrade", val)
							}
							style="rectangle"
						/>
					</div>
					<div className={styles.inputOuter}>
						<div className={styles.inputLabel}>School Year</div>
						<Dropdown
							className={styles.yearDropdown}
							options={yearOpts}
							initialValue={this.state.selectedYear}
							updateSelection={val => this.updateSelection("selectedYear", val)}
							style="rectangle"
						/>
					</div>
				</div>
				<div>
					<div className={styles.inputLabel}>
						BA Level
						<InfoIcon
							className={styles.infoLabel}
							text={CopyTable.getAddModalInfoIconCopy("baLevel")}
							textClass={styles.infoText}
						/>
					</div>
					<Dropdown
						className={styles.gradeDropdown}
						options={_.zipObject(
							grades,
							grades.map(g => "BA" + g)
						)}
						defaultOption="Select BA Level"
						initialValue={this.state.selectedGradeID}
						orderOptions="asc"
						updateSelection={val =>
							this.updateSelection("selectedGradeID", val)
						}
						style="rectangle"
					/>
				</div>
				{this.renderSchoolClassInfo(type)}
			</div>
		);
	},

	renderSchool() {
		return (
			<div className={styles.content}>
				{this.renderInput({
					fieldType: "displayName",
					placeholder: "school name",
				})}
			</div>
		);
	},

	renderStaff(type) {
		const {schoolState} = this.props;
		const {isTransfer, selectedUser} = this.state;
		if (isTransfer) {
			// Pick which set of staff to show.
			// Always show everyone
			// Don't want to adjust list based on what school/class they pick.
			// Better just to throw a sensible error if they choose a staff that already has that role.
			let allStaff = OpsSchool.getAllStaff(schoolState, true);
			if (type === "purchaseAdmin") {
				const allPurchaseAdmins = OpsSchool.getPurchaseAdmins(schoolState);
				// Filter out those that are already purchase admins
				allStaff = _.filter(
					allStaff,
					s =>
						!_.includes(
							allPurchaseAdmins.map(p => p.id),
							s.id
						)
				);
			}
			const emailEl = selectedUser ? selectedUser.email : "—";
			return (
				<div className={styles.content}>
					<div className={styles.inputOuter}>
						<div className={styles.inputLabel}>Name</div>
						<UserSearch
							users={allStaff}
							className={styles.autocomplete}
							onSelect={val => this.updateSelection("selectedUser", val)}
							space="modal"
						/>
					</div>
					<div className={styles.inputOuter}>
						<div className={styles.inputLabel}>Email</div>
						<div className={styles.staticInput}>{emailEl}</div>
					</div>
					{this.renderSchoolClassInfo(type)}
				</div>
			);
		} else {
			return (
				<div className={styles.content}>
					<div className={styles.twoInput}>
						{this.renderInput({
							fieldType: "firstName",
							placeholder: "first name",
						})}
						{this.renderInput({
							fieldType: "lastName",
							placeholder: "last name",
						})}
					</div>
					{this.renderInput({fieldType: "email", placeholder: "email"})}
					{this.renderSchoolClassInfo(type)}
				</div>
			);
		}
	},

	renderStudent(type) {
		const {
			schoolState,
			generatedUsernameObj,
			generateUsername,
			user,
		} = this.props;
		const {isTransfer, selectedUser} = this.state;
		const purchase = _.get(this.props.schoolState, "accounts.purchase");
		const {domain} = purchase;

		const students = OpsSchool.getEditableStudents(schoolState, user.userID);
		let currSchool, currClass;
		if (selectedUser) {
			currSchool = OpsSchool.getSchoolForStudent(schoolState, selectedUser.id);
			currClass = OpsSchool.getClassForStudent(schoolState, selectedUser.id);
		}
		if (!isTransfer) {
			const username = generatedUsernameObj.username;
			const renderUsername = un => {
				return (
					<div className={styles.inputOuter}>
						<div className={styles.inputLabel}>BA Username</div>
						<div className={styles.staticInput}>{un}</div>
					</div>
				);
			};
			const schoolLoginEl = domain ? (
				this.renderInput({
					fieldType: "schoolLogin",
					placeholder: "school login",
				})
			) : (
				<LoadGuard
					identifier="generatedUsername"
					status={generatedUsernameObj}
					requestLoad={generateUsername}
					loadingView={renderUsername("Loading...")}
					errorView={renderUsername("Error. Try again later.")}
					renderLoaded={() => renderUsername(username)}
				/>
			);
			return (
				<div className={styles.content}>
					<div className={styles.twoInput}>
						{this.renderInput({
							fieldType: "firstName",
							placeholder: "first name",
						})}
						{this.renderInput({
							fieldType: "lastName",
							placeholder: "last name",
						})}
					</div>
					<div className={styles.twoInput}>
						{this.renderInput({
							fieldType: "displayName",
							placeholder: "display name",
						})}
						{this.renderInput({
							fieldType: "password",
							placeholder: "password",
						})}
					</div>
					<div className={styles.twoInput}>
						{this.renderInput({
							fieldType: "intStudentID",
							placeholder: "student ID",
						})}
						{schoolLoginEl}
					</div>
					{this.renderSchoolClassInfo(type)}
				</div>
			);
		} else {
			return (
				<div className={styles.content}>
					<div className={styles.inputOuter}>
						<div className={styles.inputLabel}>Name</div>
						<UserSearch
							users={students}
							className={styles.autocomplete}
							onSelect={val => this.updateSelection("selectedUser", val)}
							space="modal"
						/>
					</div>
					<div className={styles.inputOuter}>
						<div className={styles.inputLabel}>Current School/Class</div>
						<div className={styles.staticInput}>
							{_.get(currSchool, "displayName", "(Select a student)")}
						</div>
						<div className={styles.staticInput}>
							{_.get(currClass, "displayName", "")}
						</div>
					</div>
					{this.renderSchoolClassInfo(type)}
				</div>
			);
		}
	},

	renderTransfer(type) {
		return (
			<div className={styles.content}>{this.renderSchoolClassInfo(type)}</div>
		);
	},

	typeNeedsSchool(type) {
		return _.includes(
			[
				"schoolAdmin",
				"teacher",
				"student",
				"class",
				"transfer",
				"teacherAddClass",
			],
			type
		);
	},

	typeNeedsClass(type) {
		return _.includes(
			["teacher", "student", "transfer", "teacherAddClass"],
			type
		);
	},

	getValidClasses(schoolID) {
		const {schoolState, type, userID} = this.props;
		let classes = OpsSchool.getClassesForSchool(schoolState, schoolID);
		classes = _.filter(classes, c => c.active);
		let currClasses, currClassIDs;
		if (type === "teacherAddClass") {
			currClasses = OpsSchool.getClassesForTeacher(schoolState, userID);
			currClassIDs = currClasses.map(cc => cc.id);
		} else if (type === "transfer") {
			currClasses = OpsSchool.getClassForStudent(schoolState, userID);
			currClassIDs = [currClasses && currClasses.id];
		}
		if (currClasses) {
			classes = _.filter(classes, c => !_.includes(currClassIDs, c.id));
		}
		return classes;
	},

	getValidSchools() {
		const {schoolState, user} = this.props;
		const allSchools = OpsSchool.getAllSchools(schoolState);
		const validSchools = allSchools.filter(s => {
			const bestRole = OpsSchool.getBestRoleForSchool(
				schoolState,
				user.userID,
				s.id
			);
			return bestRole === "purchaseAdmin" || bestRole === "schoolAdmin";
		});
		return validSchools;
	},

	renderSchoolClassInfo(type) {
		const {classID, schoolID, schoolState, user} = this.props;
		const {selectedSchoolID, selectedClassID} = this.state;
		let selectSchool;
		let selectClass;

		const userID = _.get(user, "model.userID");
		const isPurchaseAdmin = OpsSchool.isPurchaseAdmin(schoolState, userID);

		const typeNeedsSchool = this.typeNeedsSchool(type);
		const typeNeedsClass = this.typeNeedsClass(type);
		const classOptional = type === "teacher";
		const schoolOptional = isPurchaseAdmin && type === "teacher";

		if (!typeNeedsSchool && !typeNeedsClass) {
			return null;
		}

		if (typeNeedsSchool) {
			const schools = this.getValidSchools();
			if (!schoolID && !classID && (schools.length > 1 || schoolOptional)) {
				const schoolIDs = schools.map(s => s.id);
				const schoolNames = schools.map(s => s.displayName);
				selectSchool = (
					<Dropdown
						className={styles.dropdown}
						options={_.zipObject(schoolIDs, schoolNames)}
						defaultOption={"Select a school"}
						numOptionsShown={4}
						initialValue={selectedSchoolID && selectedSchoolID.toString()}
						orderOptions="asc"
						updateSelection={val =>
							this.updateSelection("selectedSchoolID", val)
						}
						style="rectangle"
					/>
				);
			} else if (schools.length === 1) {
				selectSchool = (
					<span className={styles.static}>{schools[0].displayName}</span>
				);
			} else if (schoolID || classID) {
				let school;
				if (schoolID) {
					school = _.get(schoolState, ["accounts", "schools", schoolID]);
				} else if (classID) {
					school = OpsSchool.getSchoolForClass(schoolState, classID);
				}
				selectSchool = (
					<span className={styles.static}>{school.displayName}</span>
				);
			}
		}
		if (typeNeedsClass) {
			if (!classID) {
				if (schoolID || selectedSchoolID) {
					const classes = this.getValidClasses(
						schoolID || parseInt(selectedSchoolID)
					);
					if (classes.length > 1 || classOptional) {
						const classIDs = classes.map(c => c.id);
						const classNames = classes.map(c => c.displayName);
						selectClass = (
							<Dropdown
								className={styles.dropdown}
								options={_.zipObject(classIDs, classNames)}
								defaultOption="Select a class"
								initialValue={selectedClassID}
								numOptionsShown={4}
								orderOptions="asc"
								updateSelection={val =>
									this.updateSelection("selectedClassID", val)
								}
								style="rectangle"
							/>
						);
					} else {
						if (!classes.length) {
							selectClass = (
								<span className={styles.static}>Please first add a class.</span>
							);
						} else {
							selectClass = (
								<span className={styles.static}>{classes[0].displayName}</span>
							);
						}
					}
				} else {
					selectClass = "";
				}
			} else {
				const classInfo = _.get(schoolState, ["accounts", "classes", classID]);
				selectClass = (
					<span className={styles.static}>{classInfo.displayName}</span>
				);
			}
		}

		const schoolEl = selectSchool ? (
			<div className={styles.inputOuter}>
				<span className={styles.inputLabel}>School</span>
				{selectSchool}
			</div>
		) : null;

		let classEl;
		if (selectClass) {
			classEl = (
				<div className={styles.inputOuter}>
					<span className={styles.inputLabel}>Class</span>
					{selectClass}
				</div>
			);
		} else if (_.isString(selectClass)) {
			// Should show class but no school selected yet
			classEl = <div className={styles.inputOuter} />;
		}

		let infoClass = styles.info;
		if (typeNeedsClass) infoClass = styles.infoWithClass;
		return (
			<div className={infoClass}>
				{schoolEl}
				{classEl}
			</div>
		);
	},

	render() {
		const {
			status,
			type,
			userID,
			classID,
			schoolID,
			error,
			errorMoreInfo: originalErrorMoreInfo,
			schoolState,
		} = this.props;
		const {isTransfer, errorType} = this.state;
		const isLoading = status === "pending";

		const typeMap = {
			schoolAdmin: "Add School Admin",
			purchaseAdmin: "Add System Admin",
			transfer: "Transfer Student",
			teacherAddClass: "Add To Class",
		};

		let buttonText = `${typeMap[type] || "Add " + type}`;
		if (isTransfer && type === "student") {
			buttonText = "Transfer Student";
		}

		let createButton = (
			<div
				className={styles.button}
				onClick={this.onCreate}
				tabIndex={53}
				onKeyPress={this.getKeyHandler(this.onUpdate)}
			>
				{buttonText}
			</div>
		);
		if (isLoading) {
			createButton = (
				<div className={styles.loadingContainer}>
					<div className={styles.loading}>
						<LoadingCircle colorType="white" />
					</div>
				</div>
			);
		}

		const cancelButton = (
			<div className={styles.button} onClick={this.props.onClose} tabIndex={54}>
				Cancel
			</div>
		);

		const isSingleSchool = _.get(
			schoolState,
			"accounts.purchase.isSingleSchool"
		);
		let contents;

		let targetName = "system";
		if (schoolID) targetName = "school";
		if (classID) targetName = "class";
		let instructions = CopyTable.getAddModalInstructions({
			type,
			isSingleSchool,
			isExisting: isTransfer,
			targetName,
		});
		let errorMoreInfo;
		if (_.includes(["purchaseAdmin", "schoolAdmin", "teacher"], type)) {
			contents = this.renderStaff(type);
			errorMoreInfo = "staff";
		} else if (type === "student") {
			contents = this.renderStudent(type);
			errorMoreInfo = "student";
		} else if (type === "school") {
			contents = this.renderSchool();
		} else if (type === "class") {
			contents = this.renderClass(type);
		} else if (type === "transfer" || type === "teacherAddClass") {
			contents = this.renderTransfer(type);
			const user = OpsSchool.getUser(schoolState, userID);
			const userName = ClassesUtil.getUserName(user);
			let className;
			if (type === "transfer") {
				const studentClass = OpsSchool.getClassForStudent(schoolState, userID);
				className = studentClass.displayName;
			}
			instructions = CopyTable.getAddModalInstructions({
				type,
				targetName: userName,
				className,
				isSingleSchool,
			});
		}

		/* In certain cases, append 'moreInfo' value from the original error */
		if (
			errorMoreInfo === "staff" &&
			originalErrorMoreInfo === "school missing"
		) {
			errorMoreInfo = `${errorMoreInfo}: ${originalErrorMoreInfo}`;
		}

		const errorName = errorType || error;
		let errorMessage;
		if (errorName) {
			errorMessage = CopyTable.getErrorCopy(errorName, "add", errorMoreInfo);
		}
		const belowContents = (
			<div className={errorMessage ? styles.error : styles.errorHidden}>
				{errorMessage}
			</div>
		);

		let title = `${typeMap[type] || "Add " + _.capitalize(type)}`;
		if (type === "student" && isTransfer) {
			title = "Transfer Student";
		}

		// Can switch between adding new user or select existing user
		const canSwitch = _.includes(
			["schoolAdmin", "purchaseAdmin", "teacher", "student"],
			type
		);

		let switchEl;
		if (canSwitch) {
			const switchText = isTransfer
				? " To create a new user instead, click here."
				: " To select an existing user instead, click here.";
			switchEl = (
				<span className={styles.switch} onClick={this.toggleSwitch}>
					{switchText}
				</span>
			);
		}

		return (
			<OfficeModal
				onClose={this.onClose}
				closeOnEsc={true}
				portalContainer={null}
				closeOnBackdropClick={false}
				level="overBar"
				modalClass={styles.fieldModal}
			>
				<div className={styles.fieldContainer}>
					<div className={styles.title}>{title}</div>
					<div className={styles.instructions}>
						{instructions} {switchEl}
					</div>
					{contents}
					{belowContents}
					<div className={styles.buttonRow}>
						{createButton}
						{cancelButton}
					</div>
				</div>
			</OfficeModal>
		);
	},
});
